
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-emerald-600 text-white py-12">
      <div className="max-w-6xl mx-auto px-4">
        {/* ランキングへの目立つリンク */}
        <div className="mb-10 text-center">
          <Link
            to="/ranking"
            className="inline-flex items-center gap-3 bg-white text-teal-600 font-bold px-8 py-4 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer"
          >
            <i className="ri-trophy-line text-2xl"></i>
            <span className="text-lg">人気クレジットカード比較ランキングはこちら</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <i className="ri-bank-card-line text-teal-600 text-xl"></i>
              </div>
              <span className="text-xl font-bold">クレカ比較ナビ</span>
            </div>
            <p className="text-teal-100 text-sm leading-relaxed">
              あなたにぴったりのクレジットカードが見つかる比較サイト
            </p>
          </div>
          
          <div>
            <h3 className="font-bold mb-4">カテゴリー</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/ranking" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  総合ランキング
                </Link>
              </li>
              <li>
                <Link to="/free" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  年会費無料
                </Link>
              </li>
              <li>
                <Link to="/instant" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  即日発行
                </Link>
              </li>
              <li>
                <Link to="/student" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  学生・29歳以下
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold mb-4">人気カード</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/mitsui" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  三井住友カード（NL）
                </Link>
              </li>
              <li>
                <Link to="/rakuten" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  大手ECモール系カード
                </Link>
              </li>
              <li>
                <Link to="/recruit" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  リクルートカード
                </Link>
              </li>
              <li>
                <Link to="/dcard" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  dカード GOLD U
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold mb-4">お役立ち記事</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/articles/instant-issue" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  即日発行カード特集
                </Link>
              </li>
              <li>
                <Link to="/articles/high-return-rate" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  高還元率カード特集
                </Link>
              </li>
              <li>
                <Link to="/articles/student-cards" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  学生向けカード特集
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-teal-500 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-teal-100 text-sm">
            © 2026 クレカ比較ナビ. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
